import React from 'react';
import {REGEXP_FEEDBACK} from 'configs';

import {Button, Form, FormFeedback, FormGroup, Input, Label} from 'reactstrap';
import usePublicContact from './usePublicContact';

function PublicContactForm(props) {
  const {companyType, companyId, description, children, validation} = props;
  const {isSubmittingContact, submitContact} = usePublicContact(
    companyType,
    companyId,
    validation
  );

  return (
    <Form onSubmit={submitContact} noValidate>
      <h3>Contact us</h3>

      {description && <p className="mb-4">{description}</p>}

      <fieldset disabled={isSubmittingContact}>
        <FormGroup>
          <Label>Subject</Label>
          <Input name="enquires_name" autoComplete="off" required />
          <FormFeedback>{REGEXP_FEEDBACK.required}</FormFeedback>
        </FormGroup>

        {children}

        <FormGroup>
          <Label>Enquiry</Label>
          <Input
            type="textarea"
            name="enquires_description"
            rows="6"
            required
          />
          <FormFeedback>{REGEXP_FEEDBACK.required}</FormFeedback>
        </FormGroup>

        <hr />

        <Button color="light" type="submit" block outline>
          {isSubmittingContact ? 'Submitting...' : 'Submit'}
        </Button>
      </fieldset>
    </Form>
  );
}

export default PublicContactForm;
